import React from 'react';
import { Grid, Header } from 'semantic-ui-react';

export default function CallbackErrorPage(){
    return (
        <Grid verticalAlign="middle" centered style={{'padding': '120px'}}>
            <Grid.Row>
                <Grid.Column>
                    <Header size="large">Something went wrong! Please contact help desk.</Header>
                </Grid.Column>
            </Grid.Row>
        </Grid>
    );
}
